export type AvailableLocale = {
  id: number;
  code: string;
  title: string;
};

export const AVAILABLE_LOCALES: AvailableLocale[] = [
  { id: 1, code: "cs", title: "čeština" },
  { id: 2, code: "en", title: "english" },
  {
    id: 99,
    code: "other",
    title: "jiný",
  },
];
